import React from "react";
import IconCounts from "../mini/IconCounts";
import Power from "../../shared/Power/Power";
import { Avatar } from "antd";
import { profileCharacters } from "../../utils/helper";
import { useHistory } from "react-router-dom";

const AuthorCard = (props) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div
        className="author-card cursor-pointer"
        style={{
          marginBottom: "20px",
        }}
        onClick={() => history.push(`/blogfolio/${props?.blog?.urlSlug}/about`)}
      >
        <div className="author">
          <Avatar
            style={{
              maxWidth: "77px",
              minWidth: "77px",
              minHeight: "77px",
              maxHeight: "77px",
              lineHeight: "77px",
              fontSize: "35px",
            }}
            className="mr-4"
            icon={profileCharacters(
              props.blog?.author?.firstName,
              props.blog?.author?.lastName
            )}
            src={props.blog?.author?.profileImage}
          />
          <div className="detail ml-2">
            <h2 className="blog-name"> {props.blog?.title} </h2>
            <p className="auth-name">
              by{" "}
              <b>
                {" "}
                Dr. {props.blog?.author?.firstName}{" "}
                {props.blog?.author?.lastName
                  ? props.blog?.author?.lastName
                  : ""}{" "}
              </b>
            </p>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="flex gap-4 mr-3">
            <IconCounts type="like" count={props.blog?.likeCount} />
            <IconCounts type="follow" count={props.blog?.followCount} />
            <IconCounts type="share" count={props.blog?.shareCount} />
          </div>
          <div>
            <Power count={props.blog?.powerScore} />
          </div>
        </div>
      </div>
      <style jsx="true">
        {`
          .author-card {
            box-sizing: border-box;
            border: 1px solid #dddddd;
            border-radius: 8px;
            background-color: #ffffff;
            padding: 12px 15px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .author {
            display: flex;
            align-items: center;
            margin-bottom: 0;
          }
          .author > .ant-avatar {
            flex: 0 0 26%;
          }
          .blog-name {
            color: #333333;
            font-family: Lato;
            font-size: 1.2rem;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            margin-bottom: 8px;
          }
          .auth-name {
            color: #647490;
            font-family: Lato;
            font-size: 0.875rem;
            letter-spacing: 0;
            line-height: 19px;
            margin-bottom: 0;
            font-weight: 500;
          }
          @media only screen and (max-width: 768px) {
            .author-card {
              display: block;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default AuthorCard;
